/* eslint-disable */
import '../vendor/iframeResizer.min';
import "../vendor/owl-carousel/owl.carousel.min.css";
import GetMobileOperatingSystem from "../js/global/mobile-operating-system";
require(['../vendor/iframeResizer.min.js']);

global.jQuery = require('jquery');
var $ = global.jQuery;
window.$ = $;

let owl_carousel = require('owl.carousel');
window.fn = owl_carousel;
let ellipsis = require('../vendor/jquery-ellipsis/fewlines-min');

var ran = false;
var mobileOS = GetMobileOperatingSystem();

var windowWidth = $(window).width();

var globalAssetPath = '';

function init(assetPath) {
    globalAssetPath = assetPath;
    initOwlCarousel();
    initIFrameResizer();
    initTruncateText();
    initDiabetesCareResources();
    updateBackgroundImages();
}

function initOwlCarousel() {
    mobileOS = GetMobileOperatingSystem();
    var owl = $('.better-way .callouts.owl-carousel');
    if (mobileOS !== 'unknown') {
        owl.owlCarousel({
          loop:true,
          nav:true,
          dots: false,
          items: 1,
          navText: '',
          stagePadding: 40,
          margin: 25,
          center: true,
          startPosition: 2
        });
        owl.removeClass('non-mobile');
    }else{
      owl.owlCarousel('destroy');
      owl.addClass('non-mobile');
    }
    var owl2 = $('.frequent-quality-engagement .callouts.owl-carousel');
    if (mobileOS !== 'unknown') {
        owl2.owlCarousel({
          loop:true,
          nav:true,
          dots: false,
          items: 1,
          navText: '',
          stagePadding: 40,
          margin: 25,
          center: true,
          startPosition: 1
        });
        owl2.removeClass('non-mobile');
    }else{
      owl2.owlCarousel('destroy');
      owl2.addClass('non-mobile');
    }

    setTimeout(function() {

        var owlnav = $('.owl-nav');

        if(owlnav) {

            owlnav.find('.owl-prev').addClass('lazyload').attr('data-bg', globalAssetPath + '/img/sharecare-diabetes/carousel-left-arrow.png');
            owlnav.find('.owl-next').addClass('lazyload').attr('data-bg', globalAssetPath + '/img/sharecare-diabetes/carousel-right-arrow.png');
        }

    }, 100);
    
    
}

function initTruncateText() {

    mobileOS = GetMobileOperatingSystem();
    windowWidth = $(window).width();
    
    if(ran === true) {
        return;
    }

    
    if(mobileOS !== 'unknown') {

        $('.top-content .featured-content').fewlines({
            // text for 'read less' link
            'closeMark': 'View Less',
            // text for 'read more' link
            'openMark': 'View More',
            // display 'read more' and 'read less' links in a new line
            'newLine': true,
            // the number of lines
            'lines': 18,
            'ellipsis': ''
        });

        $('.hospitals-physician-groups .featured-content').fewlines({
            // text for 'read less' link
            'closeMark': 'View Less',
            // text for 'read more' link
            'openMark': 'View More',
            // display 'read more' and 'read less' links in a new line
            'newLine': true,
            // the number of lines
            'lines': 12,
            'ellipsis': ''
        });

        $('.diabetes-prevention-program .other-featured-content').fewlines({
            // text for 'read less' link
            'closeMark': 'View Less',
            // text for 'read more' link
            'openMark': 'View More',
            // display 'read more' and 'read less' links in a new line
            'newLine': true,
            // the number of lines
            'lines': 14,
            'ellipsis': ''
        });

        $('.diabetes-coaching .other-featured-content').fewlines({
            // text for 'read less' link
            'closeMark': 'View Less',
            // text for 'read more' link
            'openMark': 'View More',
            // display 'read more' and 'read less' links in a new line
            'newLine': true,
            // the number of lines
            'lines': 7,
            'ellipsis': ''
        });

        $('.insulin-mgmt .other-featured-content').fewlines({
            // text for 'read less' link
            'closeMark': 'View Less',
            // text for 'read more' link
            'openMark': 'View More',
            // display 'read more' and 'read less' links in a new line
            'newLine': true,
            // the number of lines
            'lines': 8,
            'ellipsis': ''
        });

        ran = true;
    }

}

function initIFrameResizer() {
    //detect Internet Explorer
    var isIE = !!navigator.userAgent.match(/Trident/g) || !!navigator.userAgent.match(/MSIE/g)

     const myIframe = document.querySelector('.form-container iframe');
     if(isIE) {
        //do nothing
     }
     else {
        iFrameResize({
            log:false,
            checkOrigin:false,
           }, myIframe);
     }
     

}

function initDiabetesCareResources() {
    const btn = $('.diabetes-care-resources .callouts-view-all');

    btn.on('click touchstart', function(e) {
        e.preventDefault();
        const callouts = $('.diabetes-care-resources .callouts');
        if(!callouts.hasClass('show')) {
            callouts.addClass('show');
            btn.find('a').text("View Less");
        }
        else {
            callouts.removeClass('show');
            btn.find('a').text("View All");
        }
        
    });
}

function updateBackgroundImages() {
    var elemBG, elemBGName, elemBGStyleName, splitString, endOfUrl, newEndOfUrl = '';
    windowWidth = $(window).width();
    elemBG = $('.quote, .featured-header-bg');
    elemBG.each(function(index) {
        if($(this).attr('data-bg') !== undefined) {
            elemBGName, splitString, endOfUrl = '';
            elemBGName = $(this).attr('data-bg');
            splitString = elemBGName.split('/');
            endOfUrl = splitString[(splitString.length) - 1];

            if($(this).attr('style') !== undefined) {
                elemBGStyleName = $(this).attr('style');
                splitString = elemBGStyleName.split('/');
                endOfUrl = splitString[(splitString.length) - 1];
                endOfUrl = endOfUrl.replace('");', '');
            }

            if(windowWidth > 1024) {
                if(endOfUrl !== '') {
                    switch (endOfUrl) {
                        case 'quote-bg-mobile.jpg':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('-mobile', '');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('-mobile', '');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        case 'mobile-header-bg.jpg':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('mobile-', '');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('mobile-', '');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        default:
                            break;
                    }
                }
            }
            else {
                if(endOfUrl != '') {
                    switch (endOfUrl) {
                        case 'quote-bg.jpg':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('quote-bg.jpg', 'quote-bg-mobile.jpg');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('quote-bg.jpg', 'quote-bg-mobile.jpg');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        case 'header-bg.jpg':
                            if($(this).attr('style') !== undefined) {
                                elemBGStyleName = elemBGStyleName.replace('header-bg.jpg', 'mobile-header-bg.jpg');
                                $(this).attr('style', elemBGStyleName);
                            }
                            elemBGName = elemBGName.replace('header-bg.jpg', 'mobile-header-bg.jpg');
                            $(this).attr('data-bg', elemBGName);
                            break;
                        default:
                            break;
                    }
                }
            }
        }
    });
}

//add simple support for background images:
document.addEventListener('lazybeforeunveil', function(e){
    var bg = e.target.getAttribute('data-bg');
    if(bg){
        var classes = (e.target.classList);
        if(classes.contains('quote')) {
            if(windowWidth > 1024) {
                bg = bg.replace('-mobile', '');
            }
        }
        e.target.style.backgroundImage = 'url(' + bg + ')';

    }
});

$(window).resize(function() {
    initOwlCarousel();
    initTruncateText();
    updateBackgroundImages();
});

export default init;